module.exports = "<ion-content>\n  <app-reports-card [commonData]='tripReportData' [report]='reportName'></app-reports-card>\n</ion-content>"